import React from "react";
import Intro from "./components/Intro";
import Experience from "./components/Experience";
import About from "./components/About";
import Projects from "./components/Projects";
import Certifications from "./components/Certifications";
import Events from "./components/Events";
import Credits from "./components/Credits";
import NavBar from "./components/NavBar";
import ResumeButton from "./components/ResumeButton";

function App() {
    return (
        <div className="min-h-screen bg-canvas">
            <NavBar />
            <ResumeButton />
            <main id="content" className="md:pl-[104px]">
                <Intro />
                <About />
                <Experience />
                <Projects />
                <Certifications />
                <Events />
                <Credits />
            </main>
        </div>
    );
}

export default App;
